<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Times New Roman;">About the Author</h1>
<p>Donald D. Yackel has spent 24 years paddling his 17-foot kayak on extended wilderness trips, traveling over 3700 miles and spending 324 days sleeping in small tents in all kinds of settings. The stories in this second book, like his first, <em>The Idling Bulldozer and Other Paddling Adventures</em>, are drawn from his experiences on some of those travels. Combining his life-long interest in writing and his natural ability as a storyteller, he is able to take the reader to places they may never see or experience. Don has been drawn to water and boats since he was a child. It’s very unlikely that that will ever change.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?476b37da